export default __webpack_public_path__ + "static/media/sidechair_example.d09c3df2.jpg";